import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { baseService } from '../base.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuditProfileService extends baseService {

  constructor(http: HttpClient, router: Router) {
    super(http, router);
  }

  private apiRoute: string = '';

  async getAuditProfiles() {
    this.apiRoute = 'auditprofile';
    return this.get(`/${this.apiRoute}`).toPromise();
  }

  async deleteAuditProfile(id: string) {
    this.apiRoute = 'auditprofile';
    return this.delete(`/${this.apiRoute}/${id}`).toPromise();
  }

  async getAuditProfileSyncsAsync(id: string) {
    const apiRoute = `/${this.apiRoute}/${id}/syncs`;

    return this.get(apiRoute).toPromise();
  }

  async getAuditProfileNumberOfTablesAsync(id: string) {
    const apiRoute = `/${this.apiRoute}/${id}/table-count`;

    return this.get(apiRoute).toPromise();
  }
}
